import { MarketingCharacteristics } from '@app/constants';

import { ProductType } from '@mfe/shared/schema-types';

export const sortProductTypesByDisplayOrder = (a: ProductType | null, b: ProductType | null) => {
  if (!a || !b) {
    return 0;
  }
  const aOrder = a.marketing_copy.ui_behaviors.characteristics?.find(
    (characteristic) => characteristic.name === MarketingCharacteristics.DISPLAY_ORDER
  )?.value;
  const bOrder = b.marketing_copy.ui_behaviors.characteristics?.find(
    (characteristic) => characteristic.name === MarketingCharacteristics.DISPLAY_ORDER
  )?.value;

  if (aOrder && bOrder) {
    if (aOrder === bOrder) {
      return 0;
    }

    return aOrder > bOrder ? 1 : -1;
  }

  if (aOrder) {
    return 1;
  }

  if (bOrder) {
    return -1;
  }

  return 0;
};
